export const modReportsColumns = {
  columnsOpenMods: [
    { name: 'due_date', title: 'Due/Entry' },
    { name: 'property_name', title: 'Client Name' },
    { name: 'contact_name', title: 'Contact Name' },
    { name: 'dsi_point_person', title: 'dsi point person' },
    { name: 'description', title: 'Description' },
    { name: 'cost', title: 'Revenue' },
    { name: 'content', title: 'Cont.' },
    { name: 'approval', title: 'Appr.' },
    { name: 'graphics', title: 'Graph' },
    { name: 'programming', title: 'Dev.' },
    { name: 'transferred', title: 'Trans.' },
    { name: 'invoiced', title: 'Invoiced' }
  ],

  columnsModsQuotes: [
    { name: 'property_number', title: 'Property Number' },
    { name: 'property_name', title: 'Property Name' },
    { name: 'tsi_contact', title: 'Assignee' },
    { name: 'product_1_desc', title: 'Description' },
    { name: 'create_date', title: 'Created' }
  ]
};


// WEBPACK FOOTER //
// ./src/components/Open Mods/modReportsColumn.ts